// eslint-disable-next-line no-restricted-imports
import styled from '@emotion/styled';
import { Box } from '@iheartjane/reefer';
import { mediaQueries, spacing } from '@iheartjane/reefer-emotion';

export const CartAlertsWrapper = styled(Box)<{
  isHeadlessWide?: boolean;
  isPendingCart?: boolean;
}>(({ isHeadlessWide, isPendingCart, theme }) => ({
  backgroundColor: theme.colors.background,
  '> :not(:first-of-type)': {
    ...spacing({ mt: 8 }),
  },
  ...spacing({
    px: isPendingCart ? 0 : 16,
    pt: isPendingCart ? 0 : 8,
    pb: 8,
  }),
  [mediaQueries.tablet('min')]: {
    '> :not(:first-of-type)': {
      ...spacing({ mt: 16 }),
    },
    ...spacing({
      px: isPendingCart || isHeadlessWide ? 0 : 24,
      pt: isPendingCart || isHeadlessWide ? 0 : 16,
      pb: 16,
    }),
  },
}));
